import css from "./Input.module.scss";
import InputMask from "react-input-mask";
import { forwardRef } from "react";

export const Input = forwardRef(
  (
    {
      type = "text",
      subButton,
      icon,
      label,
      subText,
      name,
      accept = "",
      placeholder,
      pattern,
      onChange = () => { },
      onKeyup,
      onBlur,
      defaultValue,
      disabled = false,
      required = false,
      mask,
      maskPlaceholder = "",
      value = "",
      files = [],
      className,
      classLabel,
      min,
      max,
      title,
      style
    },
    ref
  ) => {
    return (
      <>
        <span style={{ position: "relative" }}>
          {/* <span className={classLabel}> */}
          {/* Aceitar mais do que uma classe */}
          <span className={`${classLabel} ${css.classLabel}`}> 
            <span> {icon} {label} </span>
            {subButton}
          </span>

          {(type === "number" && (
            <input
              autoComplete="do-not-autofill"
              title={title}
              min={min}
              name={name}
              max={max}
              ref={ref}
              type={type}
              files={files}
              accept={accept}
              className={className}
              onChange={onChange}
              placeholder={placeholder}
              pattern={pattern}
              defaultValue={defaultValue}
              disabled={disabled}
              required={required}
              onKeyUp={onKeyup}
              onBlur={onBlur}
              value={value}
              style={style}
            />
          )) || (
              <InputMask
                autoComplete="do-not-autofill"
                title={title}
                type={type}
                files={files}
                accept={accept}
                className={className}
                onChange={onChange}
                placeholder={placeholder}
                pattern={pattern}
                defaultValue={defaultValue}
                disabled={disabled}
                required={required}
                mask={mask}
                maskChar={maskPlaceholder}
                onKeyUp={onKeyup}
                onBlur={onBlur}
                value={value}
                style={style}
              />
            )}

          <p className={css.subText}>{subText}</p>
        </span>
      </>
    );
  }
);
